function trimText(value) {
    return value === undefined || value === null ? '' : String(value).trim()
}

function pick(item, keys) {
    for (let i = 0; i < keys.length; i++) {
        const value = item[keys[i]]
        if (value !== undefined && value !== null && value !== '') {
            return value
        }
    }
    return ''
}

export function formatEmployeeLabel(item) {
    if (!item) {
        return ''
    }
    const nick = trimText(pick(item, ['userNick', 'usernick', 'USER_NICK']))
    const name = trimText(pick(item, ['userName', 'username', 'USER_NAME']))
    if (nick && name && nick !== name) {
        return `${nick} / ${name}`
    }
    return nick || name
}

export function buildEmployeeOptions(list, current) {
    const options = []
    const seen = {}
    const push = (userId, label) => {
        const id = trimText(userId)
        if (!id || seen[id]) {
            return
        }
        seen[id] = true
        options.push({ userId: id, label: trimText(label) || id })
    }
    if (current && current.userId) {
        push(current.userId, current.label)
    }
    (list || []).forEach(item => {
        if (!item) {
            return
        }
        push(pick(item, ['userId', 'userid', 'user_id', 'USER_ID']), formatEmployeeLabel(item))
    })
    return options
}

/**
 * 只生成发生变化的字段，避免把详情弹窗里未展示的字段（分享码、分成比例等）覆盖掉。
 * 返回 null 表示没有任何修改。
 */
export function buildServiceStaffUpdatePayload(detail, form) {
    const current = detail || {}
    const next = form || {}
    const id = current.id || current.distributorId
    if (!id) {
        return null
    }
    const payload = { id }
    const name = trimText(next.distributorName)
    if (name && name !== trimText(current.distributorName)) {
        payload.distributorName = name
    }
    const hasStatus = next.status !== undefined && next.status !== null && next.status !== ''
    const nextStatus = hasStatus ? Number(next.status) : NaN
    const currentStatus = current.status === undefined || current.status === null || current.status === ''
        ? 1
        : Number(current.status)
    if ((nextStatus === 0 || nextStatus === 1) && nextStatus !== currentStatus) {
        payload.status = nextStatus
    }
    const nextUserId = trimText(next.qyWeixinUserId)
    if (nextUserId && nextUserId !== trimText(current.qyWeixinUserId)) {
        payload.qyWeixinUserId = nextUserId
    }
    return Object.keys(payload).length > 1 ? payload : null
}
